module.exports = __webpack_public_path__ + "assets/info.3ee859d6.svg";